export default __webpack_public_path__ + "static/media/reunion23_w640.461f58df.jpg";